<template>
  <div>
    <div class="viewport viewport-with-bottom-nav viewport-compact" ref="viewportContainer">
      <div class="display-1 my-3">{{ $t('LocationsPage.branches') }}</div>
      <BranchesList></BranchesList>
      <template v-if="showPartners">
        <div class="display-1 my-3">{{ $t('LocationsPage.partners') }}</div>
        <PartnersList></PartnersList>
      </template>
      <div class="flex-grow-1"></div>
      <BottomNav></BottomNav>
    </div>
  </div>
</template>

<script>

import BranchesList from '@shared/components/BranchesList'
import PartnersList from '@shared/components/PartnersList'
import PartnersMixin from '@shared/mixins/PartnersMixin'
import BottomNav from '../components/BottomNav'

export default {
  name: 'LocationsPage',
  components: { BottomNav, BranchesList, PartnersList },
  mixins: [PartnersMixin],
  computed: {
    showPartners() {
      return this.getPartners().length > 0
    }
  }
}
</script>
